/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WebIcon = /*#__PURE__*/ createSvgIcon(
  'WebIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.779 7.644a.612.612 0 100-1.224.612.612 0 000 1.224zM7.603 7.032a.612.612 0 11-1.224 0 .612.612 0 011.224 0zM9.203 7.644a.612.612 0 100-1.224.612.612 0 000 1.224z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5 16c-.413 0-.766-.147-1.06-.44A1.446 1.446 0 012 14.5V5.493c0-.413.147-.765.44-1.056A1.45 1.45 0 013.5 4h13c.413 0 .766.147 1.06.44.293.295.44.648.44 1.06v9.006c0 .413-.147.765-.44 1.056A1.45 1.45 0 0116.5 16h-13zm0-1.5h13v-4.482h-13V14.5zm0-5.981h13V5.5h-13v3.019z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default WebIcon;
